import { TextInput, ImageField, TextField } from 'react-admin';
import { Box } from '@mui/material';
import { useFormState } from 'react-final-form';
import { ROLES } from '../../constants';
import {  styled } from '@mui/material/styles';
import { Grid, Typography } from '@material-ui/core';

const CustomProductList = ({ permissions }) => {
    const { values } = useFormState(); // Access form data
  
    // Conditionally filter products
    const filteredProducts = values.isFirst
      ? values?.products || [] // Show all products when isFirst is true
      : values?.products || []; // Filter by need > 0 when isFirst is false
      // delete values.products
      values["products"] = filteredProducts

    return (
      <Grid container spacing={2}>
      {filteredProducts.map((product, index) => (
        <Grid
          item
          xs={12} // Full width on mobile
          sm={6}  // 2 items per row on small screens
          md={4}  // 3 items per row on medium+ screens
          key={index}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={2}
            border={1}
            borderRadius={2}
            borderColor={product.need > 0 ? 'warning.main' : 'grey.300'} // Change border color
            boxShadow={product.need > 0 ? 6 : 1} // Increase box shadow for better visibility
            sx={{
              backgroundColor: product.need > 0 ? 'rgba(255, 165, 0, 0.2)' : 'transparent', // Light orange background for visibility
              transition: 'background-color 0.3s ease, box-shadow 0.3s ease', // Smooth transition for color change
            }}
                >
            {/* Product Image and Title */}
            <Box textAlign="center" mb={1}>
              <ImageField record={product} source="productId.icon" className="align-middle" />
              <Typography variant="body1" fontWeight="bold">
                <TextField record={product} source="productId.title" />
              </Typography>
            </Box>

            {/* Inputs */}
            <Box display="flex" flexDirection="row" gap={1} justifyContent="center" width="100%">
              {/* Supply Field - Always Disabled */}
              <TextInput
                source={`products[${index}].supply`}
                label="موجودی"
                variant="outlined"
                disabled
                style={{ width: 80 }}
              />

              {/* Need Field - Editable Only if isFirst is true */}
              <TextInput
                source={`products[${index}].need`}
                label="درخواست"
                variant="outlined"
                disabled={!values.isFirst}
                style={{ width: 80 }}
              />

              {/* Accepted Supply Field */}
              <RedNumberInput
                id="custom-css-outlined-input"
                source={`products[${index}].accepted_supply`}
                onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
                label="ارسالی"
                variant="outlined"
                color="red"
                disabled={
                  values.isFirst &&
                  ![ROLES.SUPER_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN].some(
                    (role) => permissions?.includes(role)
                  )
                }
                locales={"fa"}
                style={{
                  floodColor: "red",
                  boxShadow: 3,
                  width: 80,
                }}
              />
            </Box>
          </Box>
        </Grid>
      ))}

      {/* Empty State */}
      {filteredProducts.length === 0 && (
        <Grid item xs={12}>
          <Typography variant="body1" textAlign="center">
            هیچ محصولی یافت نشد.
          </Typography>
        </Grid>
      )}
    </Grid>
    );
  };
  const RedNumberInput = styled(TextInput)({
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
      '&:hover fieldset': {
        borderColor: 'green',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black',
      },
    },
  });

  export default CustomProductList;
